import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const DetailAdd = () => {
  const navigate = useNavigate();
  const [newPostData, setNewPostData] = useState({
    title_banner: '',
    id_bu_master: '',
    description_banner: '',
    logo_banner: null,
    images_banner: [],
    title_app: '',
    description_app: '',
    images_app: [],
    title_sec: '',
    description_sec: '',
    images_sec: [],
    title_prod_1: '',
    description_1: '',
    images_1: [],
    title_prod_2: '',
    description_2: '',
    images_2: [],
    title_prod_3: '',
    description_3: '',
    images_3: [],
    title_prod_4: '',
    description_4: '',
    images_4: [],
    gallery: [],
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [buMasters, setBuMasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const handleFileChange = (e, section) => {
    const files = Array.from(e.target.files);
    setNewPostData((prevData) => ({
      ...prevData,
      [section]: files,
    }));
  };

  const handlePost = async () => {
    // Validation: Check if all required fields are filled
    if (
      !newPostData.title_banner ||
      !newPostData.id_bu_master ||
      !newPostData.description_banner ||
      !newPostData.logo_banner ||
      !newPostData.images_banner.length ||
      !newPostData.title_app ||
      !newPostData.description_app ||
      !newPostData.images_app.length ||
      !newPostData.title_sec ||
      !newPostData.description_sec ||
      !newPostData.images_sec.length ||
      !newPostData.title_prod_1 ||
      !newPostData.description_1 ||
      !newPostData.images_1.length ||
      !newPostData.title_prod_2 ||
      !newPostData.description_2 ||
      !newPostData.images_2.length ||
      !newPostData.title_prod_3 ||
      !newPostData.description_3 ||
      !newPostData.images_3.length ||
      !newPostData.title_prod_4 ||
      !newPostData.description_4 ||
      !newPostData.images_4.length
    ) {
      Swal.fire({
        title: 'Missing Information',
        text: 'Please fill in all the required fields and upload the images.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return; // Prevent submission if validation fails
    }
  
    const formData = new FormData();
    // Append form data
    formData.append('title_banner', newPostData.title_banner);
    formData.append('id_bu_master', newPostData.id_bu_master);
    formData.append('description_banner', newPostData.description_banner);
    if (newPostData.logo_banner) {
      formData.append('logo_banner', newPostData.logo_banner);
    }
    newPostData.images_banner.forEach((image) => {
      formData.append('images_banner', image);
    });
  
    // Handle App section
    formData.append('title_app', newPostData.title_app);
    formData.append('description_app', newPostData.description_app);
    newPostData.images_app.forEach((image) => {
      formData.append('images_app', image);
    });
  
    // Handle About section
    formData.append('title_sec', newPostData.title_sec);
    formData.append('description_sec', newPostData.description_sec);
    newPostData.images_sec.forEach((image) => {
      formData.append('images_sec', image);
    });
  
    // Handle Product section
    for (let i = 1; i <= 4; i++) {
      formData.append(`title_prod_${i}`, newPostData[`title_prod_${i}`]);
      formData.append(`description_${i}`, newPostData[`description_${i}`]);
      newPostData[`images_${i}`].forEach((image) => {
        formData.append(`images_${i}`, image);
      });
    }
  
    // Handle Gallery section
    newPostData.gallery.forEach((image) => {
      formData.append('gallery', image);
    });
  
    // Set saving to true (this triggers loading spinner)
    setSaving(true);
  
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post('https://3wzg6m6x-5000.asse.devtunnels.ms/api/bu_detail/add', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      // Show success alert
      Swal.fire({
        title: 'Success!',
        text: 'Business Unit successfully added!',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/compro/Bisnis-Unit-Detail');
      });
  
    } catch (error) {
      console.error('Error adding post:', error);
      setSnackbarMessage('Failed to add Business Unit: ' + (error.response?.data?.message || 'An unexpected error occurred.'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      // Set loading to false once the request is completed
      setSaving(false);
    }
  };  

  const fetchBuMasters = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://3wzg6m6x-5000.asse.devtunnels.ms/api/bu_master', {
        headers: {
          Authorization: ` ${token}`
        }
      });
      console.log('Fetched BU Masters:', response.data); 
      setBuMasters(response.data);
    } catch (error) {
      console.error("Error fetching BU Masters:", error);
      setSnackbarMessage('Error fetching BU Masters: ' + error.message);
      setSnackbarOpen(false);
    }
  };
  
  useEffect(() => {
    fetchBuMasters();
  }, []);

  return (
    <Grid container spacing={2} sx={{ backgroundColor: 'white', p: 3, borderRadius: 2}}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontSize: '24px', }}>Add Business Unit</Typography>
      </Grid>
      <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* Column 1 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" mb={2}>App Section</Typography>
              <TextField
                label="Title Banner"
                fullWidth
                value={newPostData.title_banner}
                onChange={(e) => setNewPostData({ ...newPostData, title_banner: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel sx={{ color: 'gray' }}>Business Unit</InputLabel>
                <Select
                  value={newPostData.id_bu_master}
                  onChange={(e) => setNewPostData({ ...newPostData, id_bu_master: e.target.value })}
                >
                  {buMasters.map((bu) => (
                    <MenuItem key={bu.id} value={bu.id}>{bu.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Description Banner"
                fullWidth
                multiline
                value={newPostData.description_banner}
                onChange={(e) => setNewPostData({ ...newPostData, description_banner: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '20px' }}>
                <Typography variant="body1">Logo Banner Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setNewPostData({ ...newPostData, logo_banner: e.target.files[0] })}
                />
              </div>
              <div style={{ marginBottom: '20px', }}>
                <Typography variant="body1">Image Banner Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_banner')}
                />
              </div>
            </Grid>

            {/* Column 2 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" mb={2}>App Section</Typography>
              <TextField
                label="Title App"
                fullWidth
                value={newPostData.title_app}
                onChange={(e) => setNewPostData({ ...newPostData, title_app: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <TextField
                label="Description App"
                fullWidth
                multiline
                value={newPostData.description_app}
                onChange={(e) => setNewPostData({ ...newPostData, description_app: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '6px' }}>
                <Typography variant="body1">Image App Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_app')}
                />
              </div>
            </Grid>
          </Grid>

          {/* About Section */}
          <Typography variant="subtitle1" mb={2}>About Section</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Title About"
                fullWidth
                value={newPostData.title_sec}
                onChange={(e) => setNewPostData({ ...newPostData, title_sec: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <TextField
                label="Description About"
                fullWidth
                multiline
                value={newPostData.description_sec}
                onChange={(e) => setNewPostData({ ...newPostData, description_sec: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '6px' }}>
                <Typography variant="body1">Image About Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_sec')}
                />
              </div>
            </Grid>
          </Grid>

          {/* Product Section */}
          <Typography variant="subtitle1" mb={2}>Product Section</Typography>
          <Grid container spacing={2}>
            {Array.from({ length: 4 }, (_, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <TextField
                  label={`Title Product ${index + 1}`}
                  fullWidth
                  value={newPostData[`title_prod_${index + 1}`]}
                  onChange={(e) => setNewPostData({ ...newPostData, [`title_prod_${index + 1}`]: e.target.value })}
                  sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
                />
                <TextField
                  label={`Description Product ${index + 1}`}
                  fullWidth
                  multiline
                  value={newPostData[`description_${index + 1}`]}
                  onChange={(e) => setNewPostData({ ...newPostData, [`description_${index + 1}`]: e.target.value })}
                  sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
                />
                <div style={{ marginBottom: '20px' }}>
                  <Typography variant="body1">{`Image Product ${index + 1} Upload`}</Typography>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => handleFileChange(e, `images_${index + 1}`)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>

          {/* Gallery */}
          <Typography variant="subtitle1" mb={2}>Gallery Section</Typography>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => handleFileChange(e, 'gallery')}
            />
          </div>

          {/* Save Button */}
          <Box display="flex" justifyContent="center" sx={{ mt: 3 }}>
          <Button
  variant="contained"
  color="primary"
  onClick={handlePost}
  disabled={saving} // Disable the button while saving
>
  {saving ? (
    <CircularProgress size={24} sx={{ color: 'white' }} />
  ) : (
    'Save'
  )}
</Button>
          </Box>
        </Grid>

<Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
<Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
  {snackbarMessage}
</Alert>
</Snackbar>
    </Grid>
  );
};

export default DetailAdd;
